import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { DatePicker } from '@emburse/ui-core';
import * as style from './DatePickerEmbark.styl';
// wrapper for our embark date picker while we wait for full implementation of features
export const DatePickerEmbark = (props) => {
    const { renderInputParams, label, showClearDate, value, onChange, ignoreInitialError, error } = props;
    const onValueChange = (date, keyboardInputValue) => {
        if (isFirstLoad) {
            setIsFirstLoad(false);
        }
        return onChange(date, keyboardInputValue);
    };
    const [errorMsg, setErrorMsg] = React.useState(null);
    const [isFirstLoad, setIsFirstLoad] = React.useState(true);
    const textFieldParams = Object.assign(Object.assign({}, renderInputParams), { label: (renderInputParams === null || renderInputParams === void 0 ? void 0 : renderInputParams.label) || label, 
        // text to show a cancel button to reset the date
        // we can't have multiple end adornments because if we set InputProps, it will overwrite the default
        // calendar icon. There isn't a cancel button in the current embark version (5.19.0) - missing support for the action bar
        helperText: showClearDate && value && 'Cancel', FormHelperTextProps: {
            onClick: () => onValueChange(null)
        }, fullWidth: true, error: (Boolean(errorMsg) || Boolean(error)) && !(isFirstLoad && ignoreInitialError) });
    React.useEffect(() => {
        if (error && isFirstLoad) {
            setIsFirstLoad(false);
        }
    }, [error]);
    return (
    // TODO change the cancel button once embark is on MUI v7
    _jsx(DatePicker, Object.assign({}, props, { className: style.global, value: value || null, onChange: onValueChange, slotProps: { textField: textFieldParams }, onError: (reason, value) => {
            setErrorMsg(reason);
        } })));
};
